import FileInput from "./file-input.component";

export default FileInput;
